export const titleCase = (value: string) => {
  return value
    .toLowerCase()
    .replace("_", " ")
    .split(" ")
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    .join(" ");
};
